import React, { useCallback, useMemo } from 'react';
import { musicServicesByMusicAPIID } from 'fym-shared/src/music-services/allMusicServices';
import { TypedMemo } from '../../../common/types';
import { Spacer } from '../../../common/views/spacer/Spacer';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { ButtonColor } from '../../../common/views/FYMButton/props';

interface PresaveServiceToggleProps {
  /** A `MusicAPIIntegrationID` value. */
  integrationType: string;
  checked: boolean;
  disabled?: boolean;
  onToggle: (integrationType: string) => void;
}

/** One music service in the pre-save block's service list. */
const PresaveServiceToggleComponent: React.FC<PresaveServiceToggleProps> = ({
  integrationType,
  checked,
  disabled,
  onToggle,
}) => {
  const handleClick = useCallback(() => {
    onToggle(integrationType);
  }, [integrationType, onToggle]);

  const color: ButtonColor = checked ? 'primary' : 'dark';
  // A service we do not know by name is still selectable: the label falls back
  // to its id rather than drawing an empty button.
  const label = useMemo(() => musicServicesByMusicAPIID[integrationType]?.name ?? integrationType, [integrationType]);

  return (
    <Spacer marginRight={5} marginBottom={5}>
      <SMLButton onClick={handleClick} color={color} size="sm" disabled={disabled}>
        {label}
      </SMLButton>
    </Spacer>
  );
};

export const PresaveServiceToggle = TypedMemo(PresaveServiceToggleComponent);
